import { http } from '../../http';
import { ResponseSearchCustomDataValues } from './types';

export const searchCustomDataValues = async (
    customDataTypeId: string,
    query: string
): Promise<ResponseSearchCustomDataValues> => {
    return http
        .get<ResponseSearchCustomDataValues>(`filter/custom-data/${customDataTypeId}/values`, {
            params: { query },
        })
        .then((response) => response.data);
};
